import { PRESUPUESTADOR_SET_INTEGRATION_CLIENT } from '../constants'

export function setIntegrationClient({
    externalId,
    client = {},
    origin,
    target,
    platform
}) {
    return dispatch => {
        dispatch({
            type: PRESUPUESTADOR_SET_INTEGRATION_CLIENT,
            data: { externalId, client, origin, target, platform }
        })
    }
}
